import React from 'react';
import { TimeSignal } from 'graphql/types';
import { useNotesFilterContext } from '../NotesFilterContextProvider';
import { NotesTotalsByDay } from '../hooks';
import NotesListDayGroup from './NotesListDayGroup';

type NotesListProps = {
  summaryByDay?: NotesTotalsByDay;
  notesMap: Record<string, TimeSignal[]>;
  onExpandCollapse: (day: string) => void;
  expandAll: boolean;
  groupedNotesExpansionState: Record<string, boolean>;
};
export const NotesList: React.FC<NotesListProps> = ({
  notesMap,
  onExpandCollapse,
  expandAll,
  groupedNotesExpansionState
}: NotesListProps) => {
  const {
    filterContext: { selectedClassification }
  } = useNotesFilterContext();
  return (
    <div
      data-testid={`expand-collapsed-notes-list_${selectedClassification.toLowerCase()}`}
    >
      {Object.keys(notesMap)
        .map((noteDate) => {
          return (
            notesMap[noteDate].length && (
              <NotesListDayGroup
                key={noteDate}
                day={noteDate}
                expandAll={expandAll}
                groupedNotesExpansionState={groupedNotesExpansionState}
                notes={notesMap[noteDate]}
                totalCount={notesMap[noteDate].length}
                onExpandCollapse={onExpandCollapse}
              />
            )
          );
        })
        .filter((x) => x)}
    </div>
  );
};

export default React.memo(NotesList);
